import React, { useState, useEffect } from "react";
import { Carousel } from "primereact/carousel";

import Chart from "chart.js/auto";
import axios from "axios";

// import "../dashboardStyle/dash.css";

import { DashStk } from "./DashStockage/dashStockage";

import { DashRetard } from "./DashRetard/dashRetard";
import { DashRetard2 } from "./DashRetard/dashRetard2";

import { LineChart22 } from "./dashPeriodique/dashPeriode22";
import { LineChart23 } from "./dashPeriodique/dashPeriode23";
import { LineChart24 } from "./dashPeriodique/dashPeriode24";

import { DoughnutChartFiche } from "./fiche/fiche";
import { DoughnutChartFicheDem } from "./fiche/ficheDem";

import MailStatsChart from "./MailsStats/stockMailsChart";
import DemMailStatsChart from "./MailsStats/demMailsChart";

import { DashStkTout } from "./DashStockage/dashPrincStoc";
import { DashRDC } from "./DashStockage/dashRDC";
import { DashETG } from "./DashStockage/dashEtage";
import { DashConteneurs } from "./DashStockage/dashConteneurs";

import { Box, fontStyle } from "@mui/system";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import useMediaQuery from "@mui/material/useMediaQuery";
export const Dash = () => {
  const [value, setValue] = React.useState("1");

  const isMobilePortrait = useMediaQuery("(max-width:1207px) ");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

 const cardBaseStyle = {
  background: "#fff",
  borderRadius: "5px",
  boxShadow: "0 1px 1px rgba(0,0,0,0.01)",
  padding: "5px",
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
};

const cardTitleStyle = {
  fontWeight: 600,
  fontSize: "14px",
  marginBottom: "5px",
  color: "#333",
  borderBottom: "1px solid #eee",
  paddingBottom: "10px",
};


  return (
    <>
      {isMobilePortrait && (
          <TabContext value={value}>
            <Box
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px"
              }}
            >
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons={false}
                allowScrollButtonsMobile
                sx={{
                  "& .MuiTabs-flexContainer": {
                    justifyContent: "flex-start",
                  },
                }}
              >
                <Tab label="Fiches" value="1" />
                <Tab label="Mails" value="2" />
                <Tab label="Occupation" value="3" />
                <Tab label="Retards" value="4" />
                <Tab label="Entrée/Sortie" value="5" />
              </TabList>
            </Box>

            <TabPanel value="1" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Fiches stock (j - 30)
                  </div>
                  <DoughnutChartFiche />
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Fiches dem (j - 30)
                  </div>
                  <DoughnutChartFicheDem />
                </div>
              </Box>
            </TabPanel>
            <TabPanel value="2" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Statistiques Mails Stock (j - 30)
                  </div>
                  <MailStatsChart />
                </div>

                <div>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "18px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    Statistiques Mails Dem (j - 30)
                  </div>
                  <DemMailStatsChart />
                </div>
              </Box>
            </TabPanel>

            <TabPanel value="3" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <DashStk />
              </Box>
            </TabPanel>

            <TabPanel value="4" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <DashRetard />

                <DashRetard2 />
              </Box>
            </TabPanel>
            <TabPanel value="5" sx={{ padding: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <LineChart22 />

                <LineChart24 />

                <LineChart23 />
              </Box>
            </TabPanel>
          </TabContext>
      )}

      {!isMobilePortrait && (
        <div
          style={{
            padding: "25px",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            backgroundColor: "#f4f7f9",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: "20px",
            }}
          >
            <div
              style={{
                gridColumn: "span 2",
                ...cardBaseStyle,
                padding: "20px",
                margin: 0,
              }}
            >
              <h3
                style={{
                  fontWeight: "600",
                  zIndex: "22",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                Statistiques
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "20px",
                }}
              >
                <div style={{ padding: "0" }}>
                  <h3 style={cardTitleStyle}>Fiches stock (j - 30)</h3>
                  <DoughnutChartFiche />
                </div>

                <div style={{ padding: "0" }}>
                  <h3 style={cardTitleStyle}>Fiches déménagement (j - 30)</h3>
                  <DoughnutChartFicheDem />
                </div>

                <div style={{ padding: "0" }}>
                  <h3 style={cardTitleStyle}>
                    Statistiques Mails Stock (j - 30)
                  </h3>
                  <MailStatsChart />
                </div>

                <div style={{ padding: "0" }}>
                  <h3 style={cardTitleStyle}>
                    Statistiques Mails Dem (j - 30)
                  </h3>
                  <DemMailStatsChart />
                </div>
              </div>
            </div>

            <div
              style={{
                gridColumn: "span 2",
                ...cardBaseStyle,
                padding: "20px",
                margin: 0,
              }}
            >
              <h3
                style={{
                  fontWeight: "600",
                  zIndex: "22",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                Occupations
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "20px",
                }}
              >
                <div style={{ padding: "0" }}>
                  <DashStkTout />
                </div>

                <div style={{ padding: "0" }}>
                  <DashRDC />
                </div>

                <div style={{ padding: "0" }}>
                  <DashETG />
                </div>

                <div style={{ padding: "0" }}>
                  <DashConteneurs />
                </div>
              </div>
            </div>

            <div
              style={{
                gridColumn: "span 1",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <div style={{ ...cardBaseStyle, padding: "20px" }}>
                <DashRetard />
              </div>
              <div style={{ ...cardBaseStyle, padding: "20px" }}>
                <DashRetard2 />
              </div>
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", // 3 colonnes égales
              gap: "20px",
            }}
          >
            <div style={cardBaseStyle}>
              <LineChart22 />
            </div>
            <div style={cardBaseStyle}>
              <LineChart23 />
            </div>
            <div style={cardBaseStyle}>
              <LineChart24 />
            </div>
          </div>

        </div>
      )}
    </>
  );

  
};
